exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paginator__pagination___3TGwV li a{padding:10px 20px;font-family:Noto Sans,sans-serif;font-size:18px;color:#00aeef}.paginator__pagination___3TGwV li a:hover{color:#00aeef}.paginator__pagination___3TGwV li.paginator__active___SRMjE{background-color:#00aeef!important;border-color:#00aeef;font-size:49px}.pagination li.active a{background-color:#00aeef!important;border-color:#00aeef!important}", ""]);

// exports
exports.locals = {
	"pagination": "paginator__pagination___3TGwV",
	"active": "paginator__active___SRMjE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/paginator.scss
// module id = 1073
// module chunks = 0